"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BaseMarketplaceStarRating", {
  enumerable: true,
  get: function get() {
    return _baseMarketplaceStarRating["default"];
  }
});
Object.defineProperty(exports, "LAYOUTS", {
  enumerable: true,
  get: function get() {
    return _baseMarketplaceStarRating.LAYOUTS;
  }
});
Object.defineProperty(exports, "TOOLTIP_TEXT", {
  enumerable: true,
  get: function get() {
    return _baseMarketplaceStarRating.TOOLTIP_TEXT;
  }
});
exports["default"] = exports.getMappedProps = void 0;

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));

var _omitBy2 = _interopRequireDefault(require("lodash/omitBy"));

var _isNumber2 = _interopRequireDefault(require("lodash/isNumber"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _deprecate = require("@nerdwallet/deprecate");

var _common = require("@nerdwallet/marketplace/selectors/common");

var _baseMarketplaceStarRating = _interopRequireWildcard(require("./base-marketplace-star-rating"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// export for testin.
var getMappedProps = function getMappedProps(_ref) {
  var marketplaceEntity = _ref.marketplaceEntity,
      ratingTextHref = _ref.ratingTextHref,
      starRating = _ref.starRating,
      props = _objectWithoutProperties(_ref, ["marketplaceEntity", "ratingTextHref", "starRating"]);

  return _objectSpread({
    productType: (0, _common.getProductType)(marketplaceEntity),
    ratingTextHref: ratingTextHref || (0, _common.getLearnMoreLink)(marketplaceEntity),
    // Check isNumber to bypass 0 evaluating as falsy
    starRating: (0, _isNumber2["default"])(starRating) ? starRating : (0, _common.getStarRating)(marketplaceEntity)
  }, (0, _omitBy2["default"])(props, function (val) {
    return (0, _isUndefined2["default"])(val);
  }));
};

exports.getMappedProps = getMappedProps;

var MarketplaceStarRating = function MarketplaceStarRating(props) {
  (0, _deprecate.useDeprecatedPropsWarning)({
    component: 'MarketplaceStartRating',
    deprecatedProps: [{
      version: '2.11.0',
      deprecated: 'enableAnalytics',
      migration: 'use analytics instead'
    }],
    props: props
  });
  return /*#__PURE__*/_react["default"].createElement(_baseMarketplaceStarRating["default"], getMappedProps(props));
};

MarketplaceStarRating.propTypes = {
  // Note: MarketplaceStarRating supports all BaseMarketplaceStarRating props as manual overrides.
  // None of these props are required if passing a valid `marketplaceEntity`
  // They are copied here for doc-gen because this doesn't work :(
  // ...BaseMarketplaceStarRating.propTypes
  analytics: _propTypes["default"].shape({
    entityName: _propTypes["default"].string
  }),

  /** Optional classes to apply to the outer container. */
  className: _propTypes["default"].string,

  /** (Deprecated) A flag enabling anaytics */
  enableAnalytics: _propTypes["default"].bool,

  /** Specify alternate layouts from the enum list [inline, stacked, big-number]. */
  layout: _propTypes["default"].string,

  /** Href for the rating link. */
  ratingTextHref: _propTypes["default"].string,

  /** If true, the link to the review on the rating text will be omitted */
  omitRatingTextHref: _propTypes["default"].bool,

  /** Tooltip for the rating text. */
  ratingTextTooltip: _propTypes["default"].string,

  /** Shows not yet rated component with empty star rating */
  showNotYetRated: _propTypes["default"].bool,

  /** Gives both rating text and help bubble a NDS Type size 1 instead of size 2 */
  smallRatingText: _propTypes["default"].bool,

  /** Star rating value. */
  starRating: _propTypes["default"].number,

  /** Hides the numerical rating. */
  hideNumber: _propTypes["default"].bool,

  /** Tracking location (required if ratingTextHref is specified). */
  trkLocation: _propTypes["default"].string,

  /** Tracking page type (required if ratingTextHref is specified). */
  trkPageType: _propTypes["default"].string,

  /** Tracking taxonomy (required if ratingTextHref is specified). */
  trkTaxonomy: _propTypes["default"].shape({
    /** Taxonomy page type. */
    pageType: _propTypes["default"].string,

    /** Taxonomy topic. */
    topic: _propTypes["default"].string,

    /** Taxonomy vertical. */
    vertical: _propTypes["default"].string
  }),

  /** Marketplace entity to render. */
  marketplaceEntity: _propTypes["default"].object.isRequired // eslint-disable-line react/forbid-prop-types

};
MarketplaceStarRating.defaultProps = {
  analytics: {}
};
var _default = MarketplaceStarRating;
exports["default"] = _default;